import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { DefaultCustomer } from '@/core/customer';
import AuthStateEnum from '@/core/auth-state-enum';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
	storage: window.sessionStorage,
});

export default new Vuex.Store({
	state: {
		authState: AuthStateEnum.NOT_AUTHENTICATED,
		authErrorCode: '',
		authErrorMessage: '',
		ac: false,
		font: 16,
		pounds: false,
		accessKey: '',
		msisdn: true,
		metadataCookie: '',
		config: '',
		reason: '',
		code: '',
		barCode: '',
		pinToken: '',
		sendCodeErrorCount: 0,
		validateCodeErrorCount: 0,
		pin2: '',
		pin: '',
		document: '',
		customer: { ...DefaultCustomer },
		protocol: '',
		phoneNumber: '',
		timerStatus: 0,
		timerCounter: 0,
		eligibilityErrorsCount: 0,
		authenticityCheckErrorCount: 0,
		authenticityCheckStep1Loaded: false,
		authenticityCheckStep1Question: '',
		authenticityCheckStep1Answer: '',
		authenticityCheckStep1Options: [],
		authenticityCheckStep2Loaded: false,
		authenticityCheckStep2Question: '',
		authenticityCheckStep2Answer: '',
		authenticityCheckStep2Options: [],
		authenticityCheckStep3Loaded: false,
		authenticityCheckStep3Question: '',
		authenticityCheckStep3Answer: '',
		authenticityCheckStep3Options: [],
		progressValue: 0,
		progressEnabled: true,
		cpfConsultErrors: 0,
		tokenConsultErrors: 0,
		flowSelected: '',
		routeStack: [],
		urlEsim: ',',
		iccidEsim: '',
		flowEsim: false,
		selectedBrand: ''
	},
	mutations: {
		authState(state, value) {
			state.authState = value;
		},
		authErrorCode(state, value) {
			state.authErrorCode = value;
		},
		authErrorMessage(state, value) {
			state.authErrorMessage = value;
		},
		setAc(state) {
			state.ac = !state.ac;
		},
		font(state, value) {
			state.font = value;
		},
		pounds(state) {
			state.pounds = !state.pounds;
		},
		accessKey(state, value) {
			state.accessKey = value;
		},
		msisdn(state, value) {
			state.msisdn = value;
		},
		metadataCookie(state, value) {
			state.metadataCookie = value;
		},
		config(state, value) {
			state.config = value;
		},
		reason(state, value) {
			state.reason = value;
		},
		code(state, value) {
			state.code = value;
		},
		barCode(state, value) {
			state.barCode = value;
		},
		pin2(state, value) {
			state.pin2 = value;
		},
		pin(state, value) {
			state.pin = value;
		},
		pinToken(state, value) {
			state.pinToken = value;
		},
		sendCodeErrorCount(state, value) {
			state.sendCodeErrorCount = value;
		},
		validateCodeErrorCount(state, value) {
			state.validateCodeErrorCount = value;
		},
		customer(state, value) {
			state.customer = value;
		},
		document(state, value) {
			state.document = value;
		},
		protocol(state, value) {
			state.protocol = value;
		},
		phoneNumber(state, value) {
			state.phoneNumber = value;
		},
		timerStatus(state, value) {
			state.timerStatus = value;
		},
		timerCounter(state, value) {
			state.timerCounter = value;
		},
		eligibilityErrorsCount(state, value) {
			state.eligibilityErrorsCount = value;
		},
		authenticityCheckErrorCount(state, value) {
			state.authenticityCheckErrorCount = value;
		},
		authenticityCheckStep1Loaded(state, value) {
			state.authenticityCheckStep1Loaded = value;
		},
		authenticityCheckStep1Question(state, value) {
			state.authenticityCheckStep1Question = value;
		},
		authenticityCheckStep1Answer(state, value) {
			state.authenticityCheckStep1Answer = value;
		},
		authenticityCheckStep1Options(state, value) {
			state.authenticityCheckStep1Options = value;
		},
		authenticityCheckStep2Loaded(state, value) {
			state.authenticityCheckStep2Loaded = value;
		},
		authenticityCheckStep2Question(state, value) {
			state.authenticityCheckStep2Question = value;
		},
		authenticityCheckStep2Answer(state, value) {
			state.authenticityCheckStep2Answer = value;
		},
		authenticityCheckStep2Options(state, value) {
			state.authenticityCheckStep2Options = value;
		},
		authenticityCheckStep3Loaded(state, value) {
			state.authenticityCheckStep3Loaded = value;
		},
		authenticityCheckStep3Question(state, value) {
			state.authenticityCheckStep3Question = value;
		},
		authenticityCheckStep3Answer(state, value) {
			state.authenticityCheckStep3Answer = value;
		},
		authenticityCheckStep3Options(state, value) {
			state.authenticityCheckStep3Options = value;
		},
		progressValue(state, value) {
			state.progressValue = value;
		},
		progressEnabled(state, value) {
			state.progressEnabled = value;
		},
		cpfConsultErrors(state, value) {
			state.cpfConsultErrors = value;
		},
		cleanCustomer(state) {
			state.document = '';
			state.pinToken = '';
			state.code = '';
		},
		tokenConsultErrors(state, value) {
			state.tokenConsultErrors = value;
		},
		flowSelected(state, value) {
			state.flowSelected = value;
		},
		routeStack(state, value) {
			state.routeStack = [...state.routeStack, value];
		},
		popRoute(state) {
			const newStack = state.routeStack;
			newStack.pop();
			state.routeStack = newStack;
		},
		rewriteRoute(state, value) {
			state.routeStack = value;
		},
		restoreStack(state) {
			state.routeStack = ['/'];
		},
		urlEsim(state, value) {
			state.urlEsim = value;
		},
		iccidEsim(state, value) {
			state.iccidEsim = value;
		},
		flowEsim(state, value) {
			state.flowEsim = value;
		},
		selectedBrand(state, value) {
			state.selectedBrand = value;
		}
	},
	actions: {
		authState(context, value) {
			context.commit('authState', value);
		},
		authErrorCode(context, value) {
			context.commit('authErrorCode', value);
		},
		authErrorMessage(context, value) {
			context.commit('authErrorMessage', value);
		},
		contrast(context) {
			context.commit('setAc');
		},
		font(context, value) {
			context.commit('font', value);
		},
		pounds(context) {
			context.commit('pounds');
		},
		accessKey(context, value) {
			context.commit('accessKey', value);
		},
		msisdn(context, value) {
			context.commit('msisdn', value);
		},
		metadataCookie(context, value) {
			context.commit('metadataCookie', value);
		},
		config(context, value) {
			context.commit('config', value);
		},
		reason(context, value) {
			context.commit('reason', value);
		},
		code(context, value) {
			context.commit('code', value);
		},
		barCode(context, value) {
			context.commit('barCode', value);
		},
		pin2(context, value) {
			context.commit('pin2', value);
		},
		pin(context, value) {
			context.commit('pin', value);
		},
		pinToken(context, value) {
			context.commit('pinToken', value);
		},
		sendCodeErrorCount(context, value) {
			context.commit('sendCodeErrorCount', value);
		},
		validateCodeErrorCount(context, value) {
			context.commit('validateCodeErrorCount', value);
		},
		customer(context, value) {
			context.commit('customer', value);
		},
		document(context, value) {
			context.commit('document', value);
		},
		protocol(context, value) {
			context.commit('protocol', value);
		},
		phoneNumber(context, value) {
			context.commit('phoneNumber', value);
		},
		timerStatus(context, value) {
			context.commit('timerStatus', value);
		},
		timerCounter(context, value) {
			context.commit('timerCounter', value);
		},
		eligibilityErrorsCount(context, value) {
			context.commit('eligibilityErrorsCount', value);
		},
		authenticityCheckErrorCount(context, value) {
			context.commit('authenticityCheckErrorCount', value);
		},

		authenticityCheckStep1Loaded(context, value) {
			context.commit('authenticityCheckStep1Loaded', value);
		},
		authenticityCheckStep1Question(context, value) {
			context.commit('authenticityCheckStep1Question', value);
		},
		authenticityCheckStep1Answer(context, value) {
			context.commit('authenticityCheckStep1Answer', value);
		},
		authenticityCheckStep1Options(context, value) {
			context.commit('authenticityCheckStep1Options', value);
		},
		authenticityCheckStep2Loaded(context, value) {
			context.commit('authenticityCheckStep2Loaded', value);
		},
		authenticityCheckStep2Question(context, value) {
			context.commit('authenticityCheckStep2Question', value);
		},
		authenticityCheckStep2Answer(context, value) {
			context.commit('authenticityCheckStep2Answer', value);
		},
		authenticityCheckStep2Options(context, value) {
			context.commit('authenticityCheckStep2Options', value);
		},
		authenticityCheckStep3Loaded(context, value) {
			context.commit('authenticityCheckStep3Loaded', value);
		},
		authenticityCheckStep3Question(context, value) {
			context.commit('authenticityCheckStep3Question', value);
		},
		authenticityCheckStep3Answer(context, value) {
			context.commit('authenticityCheckStep3Answer', value);
		},
		authenticityCheckStep3Options(context, value) {
			context.commit('authenticityCheckStep3Options', value);
		},
		progressValue(context, value) {
			context.commit('progressValue', value);
		},
		progressEnabled(context, value) {
			context.commit('progressEnabled', value);
		},
		cpfConsultErrors(context, value) {
			context.commit('cpfConsultErrors', value);
		},
		cleanCustomerInfos(context) {
			context.commit('cleanCustomer');
		},
		tokenConsultErrors(context, value) {
			context.commit('tokenConsultErrors', value);
		},
		flowSelected(context, value) {
			context.commit('flowSelected', value);
		},
		routeStack(context, value) {
			context.commit('routeStack', value);
		},
		popRoute(context) {
			context.commit('popRoute');
		},
		rewriteRouteStack(context, value) {
			context.commit('rewriteRoute', value);
		},
		restoreStack(context) {
			context.commit('restoreStack');
		},
		urlEsim(context, value) {
			context.commit('urlEsim', value);
		},
		iccidEsim(context, value) {
			context.commit('iccidEsim', value);
		},
		flowEsim(context, value) {
			context.commit('flowEsim', value);
		},
		selectedBrand(context, value) {
			context.commit('selectedBrand', value);
		}
	},
	getters: {
		getAuthState: (state) => {
			return state.authState;
		},
		getAuthErrorCode: (state) => {
			return state.authErrorCode;
		},
		getAuthErrorMessage: (state) => {
			return state.authErrorMessage;
		},
		getAc: (state) => {
			return state.ac;
		},
		getFontSize: (state) => {
			return state.font;
		},
		getMsisdn: (state) => {
			return state.msisdn;
		},
		getAccessKey: (state) => {
			return state.accessKey;
		},
		getConfig: (state) => {
			return state.config;
		},
		getMetadataCookie: (state) => {
			return state.metadataCookie;
		},
		getReason: (state) => {
			return state.reason;
		},
		getCode: (state) => {
			return state.code;
		},
		getBarCode: (state) => {
			return state.barCode;
		},
		getPin2: (state) => {
			return state.pin2;
		},
		getPin: (state) => {
			return state.pin;
		},
		getPinToken: (state) => {
			return state.pinToken;
		},
		getSendCodeErrorCount: (state) => {
			return state.sendCodeErrorCount;
		},
		getValidateCodeErrorCount: (state) => {
			return state.validateCodeErrorCount;
		},
		getCustomer: (state) => {
			return state.customer;
		},
		getDocument: (state) => {
			return state.document;
		},
		getProtocol: (state) => {
			return state.protocol;
		},
		getPhoneNumber: (state) => {
			return state.phoneNumber;
		},
		getTimerStatus: (state) => {
			return state.timerStatus;
		},
		getTimerCounter: (state) => {
			return state.timerCounter;
		},
		getEligibilityErrorsCount: (state) => {
			return state.eligibilityErrorsCount;
		},
		getAuthenticityCheckErrorCount: (state) => {
			return state.authenticityCheckErrorCount;
		},
		getAuthenticityCheckStep1Loaded: (state) => {
			return state.authenticityCheckStep1Loaded;
		},
		getAuthenticityCheckStep1Question: (state) => {
			return state.authenticityCheckStep1Question;
		},
		getAuthenticityCheckStep1Answer: (state) => {
			return state.authenticityCheckStep1Answer;
		},
		getAuthenticityCheckStep1Options: (state) => {
			return state.authenticityCheckStep1Options;
		},
		getAuthenticityCheckStep2Loaded: (state) => {
			return state.authenticityCheckStep2Loaded;
		},
		getAuthenticityCheckStep2Question: (state) => {
			return state.authenticityCheckStep2Question;
		},
		getAuthenticityCheckStep2Answer: (state) => {
			return state.authenticityCheckStep2Answer;
		},
		getAuthenticityCheckStep2Options: (state) => {
			return state.authenticityCheckStep2Options;
		},
		getAuthenticityCheckStep3Loaded: (state) => {
			return state.authenticityCheckStep3Loaded;
		},
		getAuthenticityCheckStep3Question: (state) => {
			return state.authenticityCheckStep3Question;
		},
		getAuthenticityCheckStep3Answer: (state) => {
			return state.authenticityCheckStep3Answer;
		},
		getAuthenticityCheckStep3Options: (state) => {
			return state.authenticityCheckStep3Options;
		},
		progressValue: (state) => {
			return state.progressValue;
		},
		progressEnabled: (state) => {
			return state.progressEnabled;
		},
		getCpfConsultErrors: (state) => {
			return state.cpfConsultErrors;
		},
		getTokenConsultErrors: (state) => {
			return state.tokenConsultErrors;
		},
		getFlowSelected: (state) => {
			return state.flowSelected;
		},
		getRouteStack: (state) => {
			return state.routeStack;
		},
		getUrlEsim: (state) => {
			return state.urlEsim;
		},
		getIccidEsim: (state) => {
			return state.iccidEsim;
		},
		getFlowEsim: (state) => {
			return state.flowEsim;
		},
		selectedBrand: (state) => {
			return state.selectedBrand;
		}
	},
	plugins: [vuexLocal.plugin],
});
